import { render } from "./UpcomingList.vue?vue&type=template&id=11a2c4d8"
import script from "./UpcomingList.vue?vue&type=script&lang=js"
export * from "./UpcomingList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__